import { render, staticRenderFns } from "./IbxItemError.vue?vue&type=template&id=f60846c6"
import script from "./IbxItemError.vue?vue&type=script&lang=ts"
export * from "./IbxItemError.vue?vue&type=script&lang=ts"
import style0 from "./IbxItemError.vue?vue&type=style&index=0&id=f60846c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports